import type { FeatureConfig } from 'src/modules/FeatureToggler/types';

import { cmsPageContentFeature } from './cmsPageContentFeature';

export const featureConfigs: FeatureConfig[] = [cmsPageContentFeature];
